<template>
  <v-container>
    <form name="message" method="post" netlify="true" netlify-honeypot="bot-field">
      <input type="hidden" name="form-name" value="nachricht" />

      <v-row>
        <v-col cols="12">
          <h4>{{ $t('contact') }}</h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-text-field name="name" :label="$t('name')" required v-model="form.name" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-text-field name="email" :label="$t('email')" required v-model="form.email" outlined></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea name="message" :label="$t('message')" v-model="form.message" outlined></v-textarea>
        </v-col>
      </v-row>
    </form>
    <v-row>
      <v-col cols="12">
        <small>{{ $t('required') }}</small>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="handleSubmit" :loading="loading">{{ $t('send') }}</v-btn>
      </v-col>
    </v-row>

    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center" height="200px">
        <div class="py-12">{{ $t('sent') }}</div>
        <v-btn class="mb-6" color="green" @click="sheet = !sheet">{{ $t('close') }}</v-btn>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    form: {
      name: "",
      email: "",
      message: ""
    },
    loading: false,
    sheet: false,
  }),
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&");
    },
    handleSubmit() {
      this.loading = true;
      const axiosConfig = {
        header: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      axios
        .post(
          "/contact",
          this.encode({
            "form-name": "message",
            ...this.form
          }),
          axiosConfig
        )
        .then(response => {
          this.form = {
            name: "",
            email: "",
            message: ""
          };
          this.sheet = true;
          this.loading = false;
        })
        .catch(function(error) {
          alert("Es ist ein Fehler aufgetreten: " + error.message);
        });
    }
  }
};
</script>